module.exports = __webpack_public_path__ + "static/media/saturn.f04766a7.png";